export default __webpack_public_path__ + "static/media/w-pattern-bg.f8043e4a.svg";